import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { auth } from "./lib/firebase";

// Pages
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import AudiencesPage from "./pages/AudiencesPage";
import LandingPage from "./pages/LandingPage";
import ProductPage from "./pages/ProductPage";
import PricingPage from "./pages/PricingPage";
import SignupPage from "./pages/SignupPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import ContactPage from "./pages/ContactPage";

// Wrapper component to handle logout with navigation
function DashboardWithLogout({ fbToken }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await auth.signOut();
    navigate("/");
  };

  return <Dashboard onLogout={handleLogout} fbToken={fbToken} />;
}

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const FB_ACCESS_TOKEN = process.env.REACT_APP_FB_ACCESS_TOKEN;

  // Listen for Firebase auth state changes
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user ? { uid: user.uid, email: user.email } : null);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = (userData) => setCurrentUser(userData);

  if (loading) {
    return (
      <p style={{ textAlign: "center", marginTop: "50px", fontSize: "18px" }}>
        Loading...
      </p>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route
          path="/signup"
          element={!currentUser ? <SignupPage onLogin={handleLogin} /> : <Navigate to="/dashboard" replace />}
        />

        {/* Login route */}
        <Route
          path="/login"
          element={!currentUser ? <LoginPage onLogin={handleLogin} /> : <Navigate to="/dashboard" replace />}
        />

        {/* Dashboard */}
        <Route
          path="/dashboard"
          element={
            currentUser ? (
              <DashboardWithLogout fbToken={FB_ACCESS_TOKEN} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Audiences */}
        <Route
          path="/audiences"
          element={
            currentUser ? (
              <AudiencesPage currentUser={currentUser} fbToken={FB_ACCESS_TOKEN} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Catch-all: redirect unknown routes to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
